export default __webpack_public_path__ + "static/media/search-icon.607cebc6.png";